import {ErrorDetails} from './error-details';

/**
 * General save response model.
 */
export class SaveResponse {
  id: string;
  message: string;
  success: boolean;
  data: { [key: string]: '', };
  errors: { [key: string]: ErrorDetails, };
}
